/**
 * 发音人数据操作工具
 */
import { SpeakerItem } from "../types/speaker";

type SpeakerInfo = {
    styleAvatar?: string
} & SpeakerItem;

interface SpeakerMap {
    [key: string]: {
        [key: string]: SpeakerInfo
    }
}

type EmotionAvatarMap = {
    [key: string]: string
}

export default class SpeakerUtils {

    allSpeakersMap: SpeakerMap;
    emotionListMap: EmotionAvatarMap;
    constructor({ allSpeakersMap, emotionListMap }) {
        this.allSpeakersMap = allSpeakersMap
        this.emotionListMap = emotionListMap
    }

    getStyleList(speaker: SpeakerInfo): SpeakerInfo[] {
        const { allSpeakersMap, emotionListMap } = this
        if (!speaker) return [];
        let key = this.fixSpeakerKey(speaker.speaker)
        let arr = Object.values(allSpeakersMap[key] || {}).map((item) => {
            let mood = item.speaker.split("@")[1];
            item.styleAvatar = emotionListMap[mood] || item.headerImage;
            return item;
        });
        arr.map((val) => {
            if (val.styleName == "通用") {
                val.styleName = "默认";
            }
        });
        if (arr[0] && arr[0].styleName !== "默认") {
            let itemIndex = arr.findIndex((item) => {
                return item.styleName === "默认";
            }),
                item = arr.splice(itemIndex, 1)[0];
            arr = [item, ...arr];
        }
        return arr;
    }

    getSpeakerById(id: number | string): SpeakerInfo | null {
        const { allSpeakersMap } = this
        if (!id) return null;
        id = parseInt(id as string)
        for (let key of Object.keys(allSpeakersMap)) {
            for (let speaker of Object.values(allSpeakersMap[key])) {
                if (speaker.id === id) {
                    return speaker;
                }
            }
        }
        return null;
    }

    getSpeakerBySpeaker(speaker: string): SpeakerInfo | null {
        if (!speaker) return null;
        speaker = this.fixSpeaker(speaker)
        const key = speaker.split('@')[0]
        const { allSpeakersMap } = this
        for (let speakerItem of Object.values(allSpeakersMap[key] || {})) {
            if (speakerItem.speaker === speaker) {
                return speakerItem;
            }
        }
        return null;
    }

    // 修正speaker字段
    fixSpeakerKey(speaker: string): string {
        speaker = this.fixSpeaker(speaker)
        return speaker.split("@")[0];
    }
    fixSpeaker(speaker: string): string {
        const { allSpeakersMap } = this
        let [key, mood = ''] = speaker.split("@")
        if (!allSpeakersMap[key]) {
            if (key.indexOf("_meet") != -1) {
                key = key.replace("_meet", "_lpcnet");
            } else {
                key = key.replace("_lpcnet", "_meet");
            }
        }
        return `${key}${mood && '@'}${mood}`
    }
    is48k(speaker: string): boolean {
        return /_48k(@|$)/i.test(speaker)
    }
}